import { ModalCloseButton } from "@chakra-ui/react";

import PrimaryButton, {
  PrimaryButtonProps,
} from "../CustomButtons/PrimaryButton";
import CustomModalFooter from "./CustomModalFooter";

interface CustomModalClosePrimaryButtonProps extends PrimaryButtonProps {
  children: string;
}

export default function CustomModalClosePrimaryButton({
  children,
  ...rest
}: CustomModalClosePrimaryButtonProps) {
  return (
    <CustomModalFooter>
      <PrimaryButton
        as={ModalCloseButton}
        w="full"
        top="initial" // reset ModalCloseButton styles
        right="initial"
        flexShrink="initial"
        {...rest}
      >
        {children}
      </PrimaryButton>
    </CustomModalFooter>
  );
}
